import type { MovementType } from "@/lib/admin-api/inventory";

interface MovementTypeBadgeProps {
  readonly type: MovementType;
}

const CONFIG: Record<MovementType, { label: string; className: string }> = {
  sale: {
    label: "Vente",
    className: "bg-blue-50 text-blue-700 border border-blue-200",
  },
  return: {
    label: "Retour",
    className: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  },
  restock: {
    label: "Réapprovisionnement",
    className: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  },
  adjustment: {
    label: "Ajustement",
    className: "bg-stone-50 text-stone-700 border border-stone-200",
  },
  damage: {
    label: "Dommage",
    className: "bg-red-50 text-red-700 border border-red-200",
  },
};

export function MovementTypeBadge({ type }: MovementTypeBadgeProps) {
  const { label, className } = CONFIG[type];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${className}`}
    >
      {label}
    </span>
  );
}
